import { render, staticRenderFns } from "./AlertScheduledDetails.vue?vue&type=template&id=16f6c352&scoped=true&"
import script from "./AlertScheduledDetails.vue?vue&type=script&lang=js&"
export * from "./AlertScheduledDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertScheduledDetails.vue?vue&type=style&index=0&id=16f6c352&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f6c352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField,VTextarea})
